import routes from "actions/routes";
import { generateCreateActionCreator, generateReadActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

const getCalls = generateReadActionCreator(routes.API_CALL_HISTORY_CALLS, ACTION_NAMES.CALL_HISTORY_CALLS);
const getRecentCalls = generateReadActionCreator(routes.API_CALL_HISTORY_RECENT_CALLS, ACTION_NAMES.CALL_HISTORY_RECENT)
const getRecentCall = generateReadOneActionCreator(routes.API_CALL_HISTORY_RECENT_CALLS, ACTION_NAMES.CALL_HISTORY_RECENT);
const setUserResult = generateUpdateActionCreator(routes.API_CALL_HISTORY_CALL, ACTION_NAMES.CALL_HISTORY_CALL_RESULT, () => {}, () => {}, "user_result");
const getCallDetails = generateReadOneActionCreator(routes.API_CALL_HISTORY_DETAILS, ACTION_NAMES.CALL_HISTORY_DETAILS);
const getUpcomingCalls = generateReadActionCreator(routes.API_CALL_HISTORY_UPCOMING_CALLS, ACTION_NAMES.CALL_HISTORY_UPCOMING_CALLS);

const setCallResult = generateUpdateActionCreator(
    routes.API_CALL_HISTORY_DETAILS,
    ACTION_NAMES.CALL_HISTORY_DETAILS
);
const setVoicemailListened = generateUpdateActionCreator(
    routes.API_CALL_VOICEMAIL_LISTENED,
    ACTION_NAMES.CALL_HISTORY_DETAILS
)

const reportCall = generateCreateActionCreator(
    routes.API_CALL_HISTORY_REPORT,
    ACTION_NAMES.CALL_HISTORY_DETAILS
);

const removeRecentCall = () => {
    return {
        type: 'REMOVE_RECENT_CALL'
    }
}

function markCall(id) {
    return {
        type: 'CALL_HISTORY_MARK_CALL',
        id
    }
}

function markAllCalls() {
    return {
        type: 'CALL_HISTORY_MARK_ALL'
    }
}

export default {
    getCalls,
    markCall,
    markAllCalls,
    getRecentCalls,
    getRecentCall,
    removeRecentCall,
    setUserResult,
    getCallDetails,
    setCallResult,
    setVoicemailListened,
    reportCall,
    getUpcomingCalls
}
